import { useState, useCallback } from 'react';

export function useCopyToClipboard() {
  const [copiedText, setCopiedText] = useState(null);
  const [error, setError] = useState(null);

  const copy = useCallback(async text => {
    if (!navigator?.clipboard) {
      setError('Clipboard не поддерживается');
      return false;
    }

    try {
      await navigator.clipboard.writeText(text);
      setCopiedText(text);
      setError(null);
      return true;
    } catch (err) {
      setError('Ошибка копирования');
      setCopiedText(null);
      return false;
    }
  }, []);

  return { copiedText, error, copy };
}
